import React from "react";

import StockBasicDataSummary from "./StockBasicDataSummary";
import StockBasicDataSummaryShimmer from "./StockBasicDataSummaryShimmer";
import useShimmerTimeout from "../../../../hooks/useShimmerTimeout";
import withQuoteData from "../../../../hocs/withQuoteData";
import { compose } from "redux";

export function StockBasicDataSummaryWrapper({ stock, quoteData, ...rest }) {
  const showShimmer = useShimmerTimeout(quoteData, stock?.id);

  if (!stock?.ticker || !stock?.market) {
    return null;
  }

  if (showShimmer) {
    return <StockBasicDataSummaryShimmer />;
  }

  const change = quoteData?.change != null ? Number(quoteData.change) : null;
  const changeValue = quoteData?.change_value != null ? Number(quoteData.change_value) : null;
  const close = quoteData?.close != null ? Number(quoteData.close) : null;
  const latestQuoteDatetimeUtc = quoteData?.datetime_utc ?? null;

  return (
    <StockBasicDataSummary
      ticker={stock.ticker}
      market={stock.market}
      change={change}
      changeValue={changeValue}
      close={close}
      latest_quote_datetime_utc={latestQuoteDatetimeUtc}
      currency={stock.currency}
      short_name={stock.short_name}
      {...rest}
    />
  );
}

export default compose(withQuoteData(false, props => props.stock.id))(
  StockBasicDataSummaryWrapper
);
